// Helpers de navegação pós-login.
/** Só aceita caminhos internos do app (evita redirecionar para fora). */
export function safeNext(next: string | null | undefined, fallback = '/app'): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) return fallback
  return next
}

export const LOGIN_ERRORS: Record<string, string> = {
  google: 'Não foi possível entrar com o Google. Tente de novo ou use e-mail e senha.',
  google_cancelado: 'O login com o Google foi cancelado.',
  google_estado: 'O login com o Google expirou. Tente de novo.',
  google_nao_verificado: 'Seu e-mail do Google não está verificado. Entre com e-mail e senha.',
}
